module.exports = __webpack_public_path__ + "src/img/empty.b58302b1.png";